import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeNomeAdministracaoConsultaAtaRegistroPrecoMP: [],
    removeAtivoConsultaAtaRegistroPrecoMP: [],
    removeExercicioConsultaAtaRegistroPrecoMP: [],
    removeNumeroConsultaAtaRegistroPrecoMP: [],
    removeExercicioLicitacaoConsultaAtaRegistroPrecoMP: [],
    removeNumeroLicitacaoConsultaAtaRegistroPrecoMP: [],
    removeObjetoConsultaAtaRegistroPrecoMP: [],
    removeDataFimInicialConsultaAtaRegistroPrecoMP: [],
    removeDataFimFinalConsultaAtaRegistroPrecoMP: [],
    removeStatusConsultaAtaRegistroPrecoMP: [],
    setMostraAplicarFiltroConsultaAtaRegistroPrecoMP: [],
    limpaFiltroConsultaAtaRegistroPrecoMP: [],
    aplicarFiltroConsultaAtaRegistroPrecoMP: ['filtro'],
})

const INITIAL_STATE = {
    administracao: [],
    ativo: '',
    exercicio: '',
    numero: '',
    exercicioLicitacao: '',
    numeroLicitacao: '',
    objeto: '',
    dataFimInicial: '',
    dataFimFinal: '',
    mostraAplicarFiltro: false,
    status: '',
}

const removeNomeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.nomeAdministracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeAtivo = (state = INITIAL_STATE, action) => {
    return { ...state, ativo: '', mostraAplicarFiltro: true }
}

const removeExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: '', mostraAplicarFiltro: true }
}

const removeNumero = (state = INITIAL_STATE, action) => {
    return { ...state, numero: '', mostraAplicarFiltro: true }
}

const removeExercicioLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacao: '', mostraAplicarFiltro: true }
}

const removeNumeroLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacao: '', mostraAplicarFiltro: true }
}

const removeObjeto = (state = INITIAL_STATE, action) => {
    return { ...state, objeto: '', mostraAplicarFiltro: true }
}

const removeDataFimInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataFimInicial: '', mostraAplicarFiltro: true }
}
const removeDataFimFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataFimFinal: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_NOME_ADMINISTRACAO_CONSULTA_ATA_REGISTRO_PRECO_MP]: removeNomeAdministracao,
    [Types.REMOVE_ATIVO_CONSULTA_ATA_REGISTRO_PRECO_MP]: removeAtivo,
    [Types.REMOVE_EXERCICIO_CONSULTA_ATA_REGISTRO_PRECO_MP]: removeExercicio,
    [Types.REMOVE_NUMERO_CONSULTA_ATA_REGISTRO_PRECO_MP]: removeNumero,
    [Types.REMOVE_EXERCICIO_LICITACAO_CONSULTA_ATA_REGISTRO_PRECO_MP]: removeExercicioLicitacao,
    [Types.REMOVE_NUMERO_LICITACAO_CONSULTA_ATA_REGISTRO_PRECO_MP]: removeNumeroLicitacao,
    [Types.REMOVE_OBJETO_CONSULTA_ATA_REGISTRO_PRECO_MP]: removeObjeto,
    [Types.REMOVE_DATA_FIM_INICIAL_CONSULTA_ATA_REGISTRO_PRECO_MP]: removeDataFimInicial,
    [Types.REMOVE_DATA_FIM_FINAL_CONSULTA_ATA_REGISTRO_PRECO_MP]: removeDataFimFinal,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_ATA_REGISTRO_PRECO_MP]: setMostraAplicarFiltro,
    [Types.REMOVE_STATUS_CONSULTA_ATA_REGISTRO_PRECO_MP]: removeStatus,
    [Types.LIMPA_FILTRO_CONSULTA_ATA_REGISTRO_PRECO_MP]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_ATA_REGISTRO_PRECO_MP]: aplicarFiltro,
})
